import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportViewerComponent } from './report-viewer/report-viewer.component';
import { HtmlContentItemComponent } from './report-items/html-content-item/html-content-item.component';
import { TextItemComponent } from './text-item/text-item.component';
import { ScaleResultsSectionsListComponent } from './report-items/scale-results-sections-list/scale-results-sections-list.component';
import { AssessmentChartsModule } from "../assessment-charts/assessment-charts.module";
import { SharedModule } from "../shared/shared.module";
import { ComputedScaleComponent } from './report-items/computed-scale/computed-scale.component';
import { AddoScaleResultsComponent } from './report-items/addo-scale-results/addo-scale-results.component';
import { ReportService } from './services/report.service';
import { ScaleSummaryComponent } from './scale-summary/scale-summary.component';
import { ScaleResultsSummaryComponent } from './report-items/scale-results-summary/scale-results-summary.component';
import { TherapistScaleResultsComponent } from './report-items/therapist-scale-results/therapist-scale-results.component';
import { ScaleQuestionsListComponent } from './scale-questions-list/scale-questions-list.component';
import { FlaggedQuestionsListComponent } from './report-items/flagged-questions-list/flagged-questions-list.component';
import { PclSummaryComponent } from './pcl-summary/pcl-summary.component';
import { ScaleResultsTableSummaryComponent } from './scale-results-table-summary/scale-results-table-summary.component';
import { ReportNavigatorService } from './services/report-navigator.service';
import { ScaleRangeContentComponent } from './scale-range-content/scale-range-content.component';
import { PclAssessmentResultsComponent } from './report-items/pcl-assessment-results/pcl-assessment-results.component';
import { PclCriteriaIconComponent } from './pcl-criteria-icon/pcl-criteria-icon.component';
import { PclGraderService } from './services/pcl-grader.service';
import { AssessmentQuestionsListComponent } from './report-items/assessment-questions-list/assessment-questions-list.component';
import { PrintDialogComponent } from './print-dialog/print-dialog.component';
import { ModalModule } from 'ngx-modal';
import { AssessmentResultViewComponent } from 'app/reports/assessment-result-view/assessment-result-view.component';
import { LoginModule } from '../login/login.module';
import { ScaleSubListComponent } from './scale-sub-list/scale-sub-list.component';
import { SummarySectionGraphItemComponent } from './report-items/summary-section-graph-item/summary-section-graph-item.component';
import { ClientAssessmentResultViewComponent } from './client-assessment-result-view/client-assessment-result-view.component';
import { QuestionActionService } from './services/question-action.service';
import { QuestionActionListComponent } from './report-items/question-action-list/question-action-list.component';
import { ScaleResultQuestionFinderService } from './services/scale-result-question-finder.service';
import { ClientScaleResultsComponent } from './report-items/client-scale-results/client-scale-results.component';
import { FlaggedQuestionsListSimpleComponent } from './report-items/flagged-questions-list-simple/flagged-questions-list-simple.component';
import { AssetResultViewComponent } from './asset-result-view/asset-result-view.component';
import { LibraryAssetsModule } from 'app/library-assets/library-assets.module';


@NgModule({
  imports: [
   SharedModule
   ,ModalModule
   ,LoginModule
   ,LibraryAssetsModule
    ,AssessmentChartsModule
  ],
  entryComponents: [ HtmlContentItemComponent, TextItemComponent, ScaleResultsSectionsListComponent
    , ComputedScaleComponent, ScaleResultsSummaryComponent, TherapistScaleResultsComponent
    , AddoScaleResultsComponent, FlaggedQuestionsListComponent, PclAssessmentResultsComponent, AssessmentQuestionsListComponent
    , QuestionActionListComponent, ClientScaleResultsComponent, FlaggedQuestionsListComponent, FlaggedQuestionsListSimpleComponent ],
  declarations: [    ReportViewerComponent, HtmlContentItemComponent, TextItemComponent, ScaleResultsSectionsListComponent, ComputedScaleComponent, AddoScaleResultsComponent, ScaleSummaryComponent, ScaleResultsSummaryComponent, TherapistScaleResultsComponent, ScaleQuestionsListComponent, FlaggedQuestionsListComponent, PclSummaryComponent, ScaleResultsTableSummaryComponent, ScaleRangeContentComponent, PclAssessmentResultsComponent, PclCriteriaIconComponent, AssessmentQuestionsListComponent, PrintDialogComponent 
  ,AssessmentResultViewComponent, ScaleSubListComponent, SummarySectionGraphItemComponent
  , ClientAssessmentResultViewComponent, QuestionActionListComponent, ClientScaleResultsComponent, FlaggedQuestionsListSimpleComponent
  , AssetResultViewComponent ]
  ,exports: [ReportViewerComponent, AssessmentResultViewComponent, AssetResultViewComponent ], providers: [ReportService, ReportNavigatorService, PclGraderService, 
    ClientAssessmentResultViewComponent, QuestionActionService, ScaleResultQuestionFinderService]
})
export class ReportsModule { }



// WEBPACK FOOTER //
// ./src/app/reports/reports.module.ts